<template>
  <div style="height: calc(100vh - 48px); display: flex; align-items: center; justify-content: center; padding: 24px; box-sizing: border-box;">
    <el-result
      icon="warning"
      title="服务暂不可用"
      :sub-title="subTitle"
    >
      <template #extra>
        <div style="display: flex; gap: 12px; justify-content: center; flex-wrap: wrap;">
          <el-button type="primary" @click="handleRetry" :loading="retrying">重试</el-button>
          <el-button @click="handleBack">返回</el-button>
        </div>
      </template>
    </el-result>
  </div>
</template>

<script>
export default {
  name: 'ServiceUnavailable',
  props: {
    message: { type: String, default: '' },
    nextRetrySeconds: { type: Number, default: 0 },
    retrying: { type: Boolean, default: false }
  },
  emits: ['retry', 'back'],
  computed: {
    subTitle() {
      const s = String(this.message || '').trim()
      const base = s ? s : '接口请求失败或服务维护中，请稍后再试。'
      const secs = Number(this.nextRetrySeconds || 0)
      if (secs > 0) {
        return `${base}（${secs}秒后自动重试）`
      }
      return base
    }
  },
  methods: {
    handleRetry() {
      this.$emit('retry')
    },
    handleBack() {
      this.$emit('back')
    }
  }
}
</script>
